/**
 * TOML Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const TomlDetector: ITypeDetector = {
  id: 'toml-detector',
  name: 'TOML Detector',
  priority: 52, // Between YAML (55) and Base64 (50)
  detectedType: SEMANTIC_TYPES.TOML,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim();
    if (!trimmed) return null;

    const lines = trimmed.split('\n');
    if (lines.length < 2) return null;

    let tomlPatterns = 0;
    let hasSectionHeader = false;

    for (const line of lines) {
      const trimmedLine = line.trim();

      if (!trimmedLine || trimmedLine.startsWith('#')) {
        if (trimmedLine.startsWith('#')) tomlPatterns++;
        continue;
      }

      // Section header: [section] or [section.subsection]
      if (/^\[[\w.-]+\]$/.test(trimmedLine)) {
        tomlPatterns++;
        hasSectionHeader = true;
        continue;
      }

      // Array of tables: [[section]]
      if (/^\[\[[\w.-]+\]\]$/.test(trimmedLine)) {
        tomlPatterns++;
        hasSectionHeader = true;
        continue;
      }

      // Key = value (TOML uses = not :)
      if (/^[\w.-]+\s*=\s*.+/.test(trimmedLine)) {
        tomlPatterns++;
        continue;
      }
    }

    const nonEmptyLines = lines.filter(l => l.trim() && !l.trim().startsWith('#')).length;
    if (nonEmptyLines > 0 && tomlPatterns / nonEmptyLines >= 0.5 && hasSectionHeader) {
      return SEMANTIC_TYPES.TOML;
    }

    return null;
  },
};
